"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseBreadcrumbsFromStaticApi = void 0;
const parseBreadcrumbsFromStaticApi = breadcrumbs => (breadcrumbs ?? []).filter(breadcrumb => !!breadcrumb.id && !!breadcrumb.title).map(breadcrumb => ({
  ItemLabel: breadcrumb.title,
  Url: breadcrumb.id
}));
exports.parseBreadcrumbsFromStaticApi = parseBreadcrumbsFromStaticApi;
//# sourceMappingURL=utils.js.map